const binding = { modules: {}, dataActions: {} };

    (binding.modules['proof-point'] = {
        c: () => require('partner/modules/proof-point/proof-point.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'proof-point',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/proof-point'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|proof-point|proof-point'] = {
                c: () => require('partner/modules/proof-point/proof-point.view.tsx'),
                cn: '__local__-__local__-proof-point'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };